import React from "react";
import LegalDocPage from "../LegalDoc/LegalDocPage";
import { LegalStructuredBody } from "../LegalDoc/LegalStructuredBody";
import { TERMS_CONTENT } from "./termsContent";

/** Lovable shell + prod Terms wording in section hierarchy. Route: /terms&conditions */
const Terms = () => (
  <LegalDocPage title="Terms of Use" lastUpdated="Jan 25th, 2025">
    <LegalStructuredBody
      notice={TERMS_CONTENT.notice}
      intro={TERMS_CONTENT.intro}
      sections={TERMS_CONTENT.sections}
    />
  </LegalDocPage>
);

export default Terms;
